import React from "react";

const PaymentDashboard = ({ title, data, color, onCategoryClick }) => {
  const colorClasses =
    color === "green"
      ? "text-emerald-700 bg-emerald-50"
      : "text-rose-700 bg-rose-50";

  return (
    <div className="bg-white shadow-md rounded-xl p-5 border border-gray-100">
      <h3 className="font-semibold mb-4 text-gray-800 text-lg">{title}</h3>

      {data.length === 0 && (
        <p className="text-gray-400 text-sm text-center py-4">No data</p>
      )}

      {data.map((item, index) => (
        <div
          key={`${item.category}-${index}`}
          onClick={() => onCategoryClick(item.category)}
          className="flex items-start justify-between mb-2 border-b border-gray-100 pb-2 pt-1 px-2 rounded-md cursor-pointer transition-all duration-200 hover:bg-gray-50 hover:shadow-sm"
        >
          <span className="text-gray-700 text-sm font-medium pr-3 break-words">
            {item.category}
          </span>

          <span
            className={`font-semibold text-sm px-2 py-1 rounded-md whitespace-nowrap ${colorClasses}`}
          >
            ₹ {Number(item.amount).toLocaleString("en-IN")}
          </span>
        </div>
      ))}
    </div>
  );
};

export default PaymentDashboard;
